import { Injectable } from '@angular/core';
import { MongoService } from './mongo.service';

@Injectable({
  providedIn: 'root'
})
export class PrizesService {

  constructor(
    private mongoService: MongoService
  ) { }

  public async clearPumpsPrizesData(){
    await this.mongoService.clearPumpsPrizesData();
  }

  public async setPumpsPrizes(prizesData: Array<string>) : Promise<any> {
    return await this.mongoService.setPumpsPrizes(prizesData);
  }

  public async getAllPumpsPrizes(): Promise<Array<any>> {
    return await this.mongoService.getAllPumpsPrizesData();
  }

  public async clearAirconditionersPrizesData(){
    await this.mongoService.clearAirconditionersPrizesData();
  }

  public async setAirconditionersPrizes(prizesData: Array<string>) : Promise<any> {
    return await this.mongoService.setAirconditionersPrizes(prizesData);
  }

  public async getAllAirconditionersPrizes(): Promise<Array<any>> {
    return await this.mongoService.getAllAirconditionersPrizesData();
  }
}
